<template>
  <div class="app" id="app">
    <h2>
      <p>1. 先 a - b - c</p>
      <p>2. 再 c - b - a （查看随机数）</p>
      <p>3. 再 a - b - c - a（查看随机数，a 永久缓存）</p>
    </h2>
    <jason-vue-navigation/>
    <!-- nav -->
    <nav>
      <router-link to="/a">去a</router-link>
      <router-link to="/b">去b</router-link>
      <router-link to="/c">去c</router-link>
    </nav>
  </div>
</template>

<script>
  export default {
    name: 'app'
  };
</script>

<style lang="scss" scoped>
  .app {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    text-align: center;
    * {
      font-size: 30px;

      a {
        display: inline-flex;
        margin: 15px;
      }
    }
  }
</style>
